import React from "react";

import {
  Column,
  Columns,
  Heading,
  Hidden,
  MarkdownLite,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import content from "./content.json";
import { getImageFromCloudinary } from "src/utils/helpers";

export const HowSection: React.FC = () => (
  <Section>
    <Hidden above="sm">
      <Stack space="xlarge">
        <Heading variant="h2" align="center">
          {content.heading}
        </Heading>
        <Columns alignX="center">
          {content.sections.slice(0, 2).map((section, index) => (
            <Column
              width="1/2"
              key={`how-section-mobile-1${index}`}
              alignX="center"
            >
              <Stack alignX="center">
                <img src={getImageFromCloudinary(101, 101, section.icon)} />
                <Text align="center">
                  <MarkdownLite>{section.text}</MarkdownLite>
                </Text>
              </Stack>
            </Column>
          ))}
        </Columns>
        <Columns alignX="center">
          {content.sections.slice(2, 4).map((section, index) => (
            <Column
              width="1/2"
              key={`how-section-mobile-2${index}`}
              alignX="center"
            >
              <Stack alignX="center">
                <img src={getImageFromCloudinary(101, 101, section.icon)} />
                <Text align="center">
                  <MarkdownLite>{section.text}</MarkdownLite>
                </Text>
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Hidden>

    <Hidden below="md">
      <Stack space="xxlarge">
        <Heading variant="h2" align="center">
          {content.heading}
        </Heading>
        <Columns>
          {content.sections.map((section, index) => (
            <Column width="1/4" key={`how-section-${index}`}>
              <Stack alignX="center">
                <Hidden below="lg">
                  <img src={getImageFromCloudinary(172, 172, section.icon)} />
                </Hidden>
                <Hidden above="md">
                  <img src={getImageFromCloudinary(128, 128, section.icon)} />
                </Hidden>
                <Text align="center">
                  <MarkdownLite>{section.text}</MarkdownLite>
                </Text>
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
